@if (isInitialized) {
  <oe-flat-widget [modalComponent]="modalComponent" [icon]="{name:'swap-vertical-outline', color:'normal'}"
    [title]="component.alias">
    <oe-flat-widget-line [name]="'GENERAL.STATE' | translate" [value]="propertyMode"
      [converter]="CONVERT_MANUAL_ON_OFF">
    </oe-flat-widget-line>
    @if (propertyMode === 'MANUAL_ON') {
      <oe-flat-widget-line [name]="chargeDischargePower.name" [value]="chargeDischargePower.value"
        [converter]="CONVERT_WATT_TO_KILOWATT">
      </oe-flat-widget-line>
    }
  </oe-flat-widget>
}